import { useEffect } from "react";

export default function useWidthTracker(setMobile: SetBoolean) {
  useEffect(() => {
    const updateMobileStatus = () => {
      setMobile(window.innerWidth < 768 || window.innerHeight < 768);
    };

    window.addEventListener("resize", updateMobileStatus);
    updateMobileStatus();
    return () => window.removeEventListener("resize", updateMobileStatus);
  }, [setMobile]);
}
